import * as React from "react";
import SectionCard, {
  SectionCardGroup,
  SectionCardGroupHorizontal,
  SectionCardHorizontal
} from "../../../../Composites/SectionCard/SectionCard";
import { DataSourceSection } from "./DataSourceSection";
import { ImportTypes } from "@/Utils/Constants";
import { DataSourceOptionsContent } from "./DataSourceOptionsContent/DataSourceOptionsContent";
import { AdditionalPhotoConfigSection } from "./AdditionalPhotoConfig/AdditionalPhotoConfigSection";
import { appstr } from "@coreapp/utils/appstr";
import { Text, Alert } from "@theorgchartdev/storybook";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";
import { getDataSourceMessage, DATA_SOURCES_TEST_PREFIX } from "./Utils";
import { PositionConfig } from "@coreapp/CoreApp/PositionConfig";
import { IsPositionChart } from "@coreapp/utils/IsPositionChart";
import { createBoldToastMessage } from "@coreapp/utils/createBoldToastMessage";
import cx from "classnames";

export const DataSourceConfiguration = ({ chartConfig, handleUpdate, onSave }) => {
  const { showPricingAndPackaging } = usePermissionCheck();

  if (!chartConfig) return;

  const isPositionChart = IsPositionChart(chartConfig);
  const positionConfig = new PositionConfig(chartConfig);
  const isSyntheticPositionChart = isPositionChart && positionConfig.isPositionSynth();
  const gapFillConfig = positionConfig.getGapFillConfig();
  const showGapFillAlert =
    isSyntheticPositionChart && gapFillConfig.enabled && positionConfig.hasGapFillNotification();

  const getGapFillAlertData = () => {
    return createBoldToastMessage("Retain positions", {
      removedFromDataSet: appstr("removed from your data set"),
      createdPositions: appstr("created positions for you to maintain"),
      appendTable: appstr("append table")
    });
  };

  const gapFillAlertData = getGapFillAlertData();

  return (
    <SectionCardGroup>
      {showGapFillAlert && (
        <Alert
          alertActions={{ closeAction: () => {} }}
          severity="info"
          withBorder
          showIcon
          style={{ marginBottom: "20px" }}
          {...gapFillAlertData.alertProps}
        >
          {gapFillAlertData.message}
        </Alert>
      )}
      <SectionCardGroupHorizontal cardCount={3} addMarginAbove={false}>
        <SectionCardHorizontal title={appstr("Main Data Source")}>
          <DataSourceSection
            type={ImportTypes.import}
            sourceDataTestId={key => `data-source-opt-${ImportTypes.import}-${key}`}
            chartConfig={chartConfig}
            onChange={handleUpdate}
            onSave={onSave}
          />
        </SectionCardHorizontal>
        <SectionCardHorizontal title={appstr("Append data sources")}>
          <DataSourceSection
            addDataTestId={"add-append-data-source"}
            sourceDataTestId={key => `data-source-opt-${ImportTypes.append}-${key}`}
            sourceOptionDataTestId={key => `data-source-val-${ImportTypes.append}-${key}`}
            type={ImportTypes.append}
            chartConfig={chartConfig}
            onChange={handleUpdate}
            onSave={onSave}
          />
        </SectionCardHorizontal>
        <SectionCardHorizontal title={appstr("Merge data sources")}>
          <DataSourceSection
            addDataTestId={`${DATA_SOURCES_TEST_PREFIX}-merge-add-button`}
            sourceOptionDataTestId={key => `${DATA_SOURCES_TEST_PREFIX}-merge-source-${key}`}
            type={ImportTypes.merge}
            chartConfig={chartConfig}
            onChange={handleUpdate}
          />
        </SectionCardHorizontal>
      </SectionCardGroupHorizontal>
      {showPricingAndPackaging && (
        <Text type={"body"} size={"small"}>
          {getDataSourceMessage(chartConfig)}
        </Text>
      )}
      <SectionCard
        title={appstr("Hierarchy")}
        description={appstr("Set the top box and add co-heads")}
      >
        <DataSourceOptionsContent chartConfig={chartConfig} handleUpdate={handleUpdate} />
      </SectionCard>
      <SectionCard
        title={appstr("Additional photo configuration")}
        description={appstr(
          "Some sources require additional photo configuration in order to pull photos"
        )}
      >
        <AdditionalPhotoConfigSection chartConfig={chartConfig} handleUpdate={handleUpdate} />
      </SectionCard>
    </SectionCardGroup>
  );
};
